import { render } from "./indexAsideMenu.vue?vue&type=template&id=bfe74616&scoped=true"
import script from "./indexAsideMenu.vue?vue&type=script&lang=js"
export * from "./indexAsideMenu.vue?vue&type=script&lang=js"

import "./indexAsideMenu.vue?vue&type=style&index=0&id=bfe74616&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe74616"]])

export default __exports__